import React from 'react';
import styled from 'styled-components';
import { ONBOARDING_THEME } from './onboardingTheme';

const StepperWrap = styled.div`
  display: flex; justify-content: center; align-items: center; gap: 8px;
  margin-bottom: 20px; flex-wrap: wrap; flex-shrink: 0;
`;
const Step = styled.div` display: flex; align-items: center; gap: 6px; `;
const Circle = styled.span`
  width: 32px; height: 32px; border-radius: 50%;
  background: ${(p) => (p.active ? ONBOARDING_THEME.accent : p.done ? ONBOARDING_THEME.success : ONBOARDING_THEME.borderLight)};
  color: ${(p) => (p.active || p.done ? '#fff' : ONBOARDING_THEME.textLight)};
  display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px;
  transition: background 0.2s, color 0.2s;
`;
const Label = styled.span`
  font-size: 12px; color: ${(p) => (p.active ? ONBOARDING_THEME.accent : ONBOARDING_THEME.textMuted)};
  font-weight: ${(p) => (p.active ? 600 : 400)};
`;
const Line = styled.span`
  width: 24px; height: 2px; background: ${(p) => (p.done ? ONBOARDING_THEME.success : ONBOARDING_THEME.border)};
`;

export default function OnboardingStepper({ steps, currentStep }) {
  return (
    <StepperWrap>
      {steps.map((label, i) => (
        <React.Fragment key={i}>
          <Step>
            <Circle active={currentStep === i + 1} done={currentStep > i + 1}>
              {currentStep > i + 1 ? '✓' : i + 1}
            </Circle>
            <Label active={currentStep === i + 1}>{label}</Label>
          </Step>
          {i < steps.length - 1 && <Line done={currentStep > i + 1} />}
        </React.Fragment>
      ))}
    </StepperWrap>
  );
}
